import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { getToolBySlug, TOOL_STATUS } from '../../data/toolsData';
import ToolPageLayout from './ToolPageLayout';

const ToolComingSoonPage = () => {
  const { slug } = useParams();
  const tool = getToolBySlug(slug);

  if (!tool) {
    return <Navigate to="/" replace />;
  }

  if (tool.status === TOOL_STATUS.READY) {
    return <Navigate to={`/tools/${tool.slug}`} replace />;
  }

  return (
    <ToolPageLayout
      title={tool.name}
      lead={tool.description}
      eyebrow="Скоро"
    >
      <div className="tool-page-panel">
        <p>{'Инструмент ещё в разработке. Мы добавим его на лендинг, как только он будет готов.'}</p>
      </div>
    </ToolPageLayout>
  );
};

export default ToolComingSoonPage;
